import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let inflight = null;

/** Views per article id ({id: n}) shared by every product card; fetched once per page load. */
export const useProductViews = () => {
  const [views, setViews] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    inflight = inflight || fetch(`${API}/api/public/product-views`).then((r) => r.json()).then((d) => { cache = d || {}; return cache; }).catch(() => (cache = {}));
    inflight.then((d) => setViews(d || {}));
  }, []);
  return views;
};

export const formatViews = (n) => (n >= 1000 ? `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k` : String(n));
